/**
 * Action types for the notes right-column panel, kept in their own module with no
 * imports.
 *
 * `actions.ts` re-exports these (so callers see one surface) but it pulls in the
 * api client and React-dependent helpers, which makes it unloadable outside a
 * browser bundle. Keeping the strings here lets `panelReducers.ts` — and its
 * tests — depend on them without dragging that graph along.
 */
export const prefix = 'notes'

export const TOGGLE_NOTES = `${prefix}/TOGGLE_NOTES`
export const TOGGLE_NOTES_OFF = `${prefix}/TOGGLE_NOTES_OFF`
export const TOGGLE_NOTES_ON = `${prefix}/TOGGLE_NOTES_ON`
export const SET_NOTES_PANEL_STATE = `${prefix}/SET_NOTES_PANEL_STATE`
export const HIDE_NOTES_PANEL = `${prefix}/HIDE_NOTES_PANEL`
export const FORCE_OPEN_NOTES_PANEL = `${prefix}/FORCE_OPEN_NOTES_PANEL`
export const CLEAR_NOTES_PANEL_FORCE = `${prefix}/CLEAR_NOTES_PANEL_FORCE`
export const REQUEST_NOTES_COMPOSER = `${prefix}/REQUEST_NOTES_COMPOSER`

/** Emitted by the add-note flow; the composer request is cleared once it lands. */
export const ADD_NOTE_SUCCESS = `${prefix}/ADD_NOTE_SUCCESS`
